
import React from 'react';
import { Button } from "@/components/ui/button";
import { Program } from '@/services/db';

interface ProgramSelectorProps {
  programs: Program[];
  selectedProgram: string | null;
  onProgramSelect: (value: string) => void;
  isProgramCompleted: (title: string) => boolean;
  onIssueCertificate: () => void;
  progress?: any;
}

const ProgramSelector = ({
  programs,
  selectedProgram,
  onProgramSelect,
  isProgramCompleted,
  onIssueCertificate,
  progress
}: ProgramSelectorProps) => {
  // Extract program title from the selected program string
  const selectedProgramTitle = selectedProgram ? selectedProgram.split(':')[0] : '';

  return (
    <div className="flex flex-col md:flex-row justify-between mb-6 gap-4">
      <div className="w-full md:w-2/3">
        <label htmlFor="program-select" className="block text-sm font-medium mb-2">
          Select Program
        </label>
        <select
          id="program-select"
          className="w-full p-2 border rounded-md bg-background"
          value={selectedProgram || ''}
          onChange={(e) => onProgramSelect(e.target.value)}
        >
          {programs.map((program, index) => {
            const isCompleted = isProgramCompleted(program.title);
            return (
              <option key={index} value={`${program.title}:${program.category}`}>
                {program.title} ({program.category}) {isCompleted ? "- Completed" : ""}
              </option>
            );
          })}
        </select>
      </div>
      
      <div className="flex items-end">
        <Button 
          onClick={onIssueCertificate} 
          disabled={
            !progress || 
            !progress.currentLevel || 
            progress.certificationStatus === 'issued' || 
            !selectedProgramTitle ||
            !isProgramCompleted(selectedProgramTitle)
          }
          className="w-full md:w-auto"
        >
          Issue Certificate
        </Button>
      </div>
    </div>
  );
};

export default ProgramSelector;
